<template>
    <div :class="[colClass]">
        <div v-for="page in children" v-show="visible[page.vmId]">
            <h2 class="df-section-title">
                {{ pageTitle(page) }}
            </h2>
            <div style="padding: 0 15px">
                <ChildrenList :children-ids="[page]" :view-only="true"></ChildrenList>
            </div>
        </div>
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent, provide, reactive } from "vue";
import { combineLatest } from "rxjs";
import { map } from "rxjs/operators";
import { BaseElementDefBase, BaseElementDefSimple } from "../elements/BaseElementDef";
import type PageDef from "../elements/PageDef";
import { ReviewPageTemplatePageSettings } from "@cs-ts/review-page-template-page-settings";
import { useObservable } from "@vueuse/rxjs";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import DisplayElementDef from "../elements/DisplayElementDef";
export default defineComponent({
    components: {
        ...components,
        //DatePicker,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<BaseElementDefSimple<ReviewPageTemplatePageSettings>, ReviewPageTemplatePageSettings>) {
        const base = setup<BaseElementDefSimple<ReviewPageTemplatePageSettings>, ReviewPageTemplatePageSettings>(props);

        const hiddenElements = reactive({ elements: base.settings.value.hiddenElements, shouldProvide: true });

        const page = (input: DisplayElementDef) => {
            return props.data.calculationContext.rootElement!.getElementsByFilter(i => i.definition.id == input.definition.settings.elementId)[0] as PageDef;
        };
        const pageTitle = (input: DisplayElementDef) => {
            return page(input).definition.settings.title;
        };

        provide("elementFilter", (el: BaseElementDefBase) => {
            return !(base.settings.value.hiddenElements || []).includes(el.id!);
        });
        provide("reviewHiddenElements", () => hiddenElements);

        const visible = useObservable(
            combineLatest(
                base.children.value.map(i =>
                    page(i as unknown as DisplayElementDef)
                        .isEnabled$(null)
                        .pipe(map(j => ({ id: i.vmId, enabled: j }))),
                ),
            ).pipe(
                map(a => {
                    const r = {} as Record<string, boolean>;
                    for (var i of a) {
                        r[i.id] = i.enabled;
                    }
                    return r;
                }),
            ),
            { initialValue: {} as Record<string, boolean> },
        );

        return {
            page,
            pageTitle,
            visible,

            ...base.expose,
        };
    },
});
</script>
